<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre8">Dramatis personae</h3>
<p class="calibre5"></p>
<table cellpadding="5" cellspacing="0" class="true" summary="Personen">
<tbody><tr class="calibre6">
<td class="calibre7"><span>Vater Helmbrecht</span><br class="calibre2"/>
<span>Mutter Helmbrecht</span><br class="calibre2"/>
<span>Griselda, ihre Tochter</span><br class="calibre2"/>
<span>Markgraf Ulrich</span><br class="calibre2"/>
<span>Graf Eberhard</span><br class="calibre2"/>
<span>Gräfin Eberhard</span><br class="calibre2"/>
<span>Graf Heinz</span><br class="calibre2"/>
<span>Die Baronin</span><br class="calibre2"/>
<span>Der Fürst</span><br class="calibre2"/>
<span>Erster Baron</span><br class="calibre2"/>
<span>Zweiter Baron</span><br class="calibre2"/>
<span>Dritter Baron</span><br class="calibre2"/>
<span>Der Schloßpropst</span><br class="calibre2"/>
<span>Der Haushofmeister</span><br class="calibre2"/>
<span>Der Kastellan</span><br class="calibre2"/>
<span>Der Arzt</span><br class="calibre2"/>
<span>Erste Dame</span><br class="calibre2"/>
<span>Zweite Dame</span><br class="calibre2"/>
<span>Die Pflegefrau</span><br class="calibre2"/>
<span>Die andere Pflegefrau</span><br class="calibre2"/>
<span>Die Kammerfrau</span><br class="calibre2"/>
<span>Die Amme</span><br class="calibre2"/>
<span>Wäscherinnen</span></td>
</tr>
</tbody>
</table>
<p></p>
<p class="calibre5"><span>Jäger, Diener, zwei Mönche,
Geistlichkeit, Taufzug</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2a15e15c